import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { IngredientsServices } from '../../../ingredients/services';
import { Globals } from '../../../../globals';
import { MenuServices } from '../../../menu/services';
import { ComboCreateDishSelectPage } from '../combo-create-dish-select/combo-create-dish-select';
import { ComboCreatePricePage } from '../combo-create-price/combo-create-price';
import { AnalyticsServices } from '../../../services/analyticsServices';
import { CartaMenuViewPage } from '../../../cartas-menus/carta-menu-view/carta-menu-view';


/**
 * Generated class for the ComboCreateFinishSectionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-combo-create-finish-section',
  templateUrl: 'combo-create-finish-section.html',
})
export class ComboCreateFinishSectionPage {

  type: any;
  section_index: any;
  section: any;
  update_state: boolean = false;
  combo_uid: string;
  show_prices: boolean;
  combo_name: boolean;
  new_combo: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientsServices: IngredientsServices,
    public menuServices: MenuServices,
    public globals: Globals,
    public analyticsServices: AnalyticsServices) {

    this.type = this.navParams.get('type'); //Menu style
    this.section_index = this.navParams.get('section'); //Section index number
    this.update_state = this.navParams.get('update');//Update state
    this.combo_uid = this.navParams.get('combo_uid');//Menu uid
    this.section = this.navParams.get('section'); //Section index number
    this.show_prices = this.navParams.get('show_prices'); //Section index number
    this.combo_name = this.navParams.get('combo_name'); //Section index number
    this.new_combo = this.navParams.get('new_combo');

    this.analyticsServices.trackingExp('crear secció combo', this.globals.tracking_exp['create_section'], '');
  }


  openNextSection() {
    this.navCtrl.push(ComboCreateDishSelectPage, {
      type: "combo",
      section: this.section_index,
      update: this.update_state,
      combo_uid: this.combo_uid,
      combo_name: this.combo_name,
      new_combo: this.new_combo
    });
  }

  finish() {
    this.globals.GAtrackView('Combo', 'Combo - Section - Create', this.globals.restaurant.email, 'Create/Update', 'Create section', 'Combo', '');
    this.updateFirestore(); //Guardamos secciones en Firestore
    if (this.new_combo == true) {
      this.analyticsServices.trackingExp('finisher', this.globals.tracking_exp['finisher'], '');
      //save plg_cartamenu_finisher true
      this.menuServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        plg_cartamenu_finisher: true
      });
      this.globals.restaurant.plg_cartamenu_finisher = true;
    }
    if (this.show_prices == undefined || this.show_prices == true) {
      this.goToPriceExtras();
    } else {
      this.navCtrl.setRoot(CartaMenuViewPage, {
        type: 'combo',
        state: 'edit',
        uid_element: this.combo_uid
      });
    }
  }

  updateFirestore() {
    this.menuServices.afs.collection('menus').doc(this.combo_uid).update({
      'sections': this.menuServices.menu_section_array_complete_tmp,
      'style': this.type
    }).then(() => {
    });
  }

  goToPriceExtras() {
    this.navCtrl.push(ComboCreatePricePage, {
      update: false,
      combo_uid: this.combo_uid,
      price: 0,
      price_takeaway: 0,
      extra_price: 0,
      type: this.type,
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/combo/combo-create/combo-create-finish-section/combo-create-finish-section.ts